module.exports = __webpack_public_path__ + "img/red_071.d86f97d0.png";